import React from 'react'
import logo from '../asset/images/logo.svg'

const Maintenance = ({ message }) => {
  const displayMessage =
    message ||
    'We are currently undergoing scheduled maintenance. Please check back shortly.'

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-slate-950 px-6 text-center">
      <div
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          background:
            'radial-gradient(ellipse 80% 50% at 50% -20%, rgba(56, 189, 248, 0.25), transparent), radial-gradient(ellipse 60% 40% at 80% 100%, rgba(14, 165, 233, 0.15), transparent)'
        }}
      />
      <div className="relative z-10 mx-auto max-w-lg">
        <img src={logo} alt="Employ Me Global" className="mx-auto mb-8 h-14 w-auto" />
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-sky-400">
          Temporarily unavailable
        </p>
        <h1 className="mb-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">
          We&apos;ll be back soon
        </h1>
        <p className="mb-8 text-base leading-relaxed text-slate-300 sm:text-lg">
          {displayMessage}
        </p>
        <div className="mx-auto h-1 w-16 overflow-hidden rounded-full bg-slate-700">
          <div className="h-full w-1/2 animate-pulse rounded-full bg-sky-400" />
        </div>
      </div>
    </div>
  )
}

export default Maintenance
